export const config = {
  BASE_URL: process.env.REACT_APP_API_MAIN_URL || 'http://localhost:8000',
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  ENCEPHALON_FRONTEND_URL: process.env.REACT_APP_ENCEPHALON_FRONTEND_URL,
  REVIEWER_URL: process.env.REACT_APP_REVIEWER_FRONTEND_URL || 'http://localhost:3001',
};
